import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { QUERY_KEY } from './getByIdV3'

export type AutoGtBreakdownVoteOrigin = 'live' | 'super_majority'

export type AutoGtBreakdownVote = {
  participationId: string
  origin: AutoGtBreakdownVoteOrigin
  engagementId: string
  taskId: string
  resolutionId: string
  operatorId: string
  inAgreementGroup: boolean
  operator: { name: string | null; avatarUrl: string | null } | null
  submittedAt: string | null
  timeToResolveMs: number | null
}

export type AutoGtBreakdown = {
  candidateId: string
  sourceLiveEngagementId: string
  autoGroundTruth: { resolutionId: string; isActive: boolean }
  decidedAt: string
  agreementCount: number
  totalVotes: number
  achievedAgreementRatio: number
  votes: AutoGtBreakdownVote[]
}

export const AUTO_GT_BREAKDOWN_QUERY_KEY_SUFFIX = 'auto-gt-breakdown'

// Nested under the engagement v3 key so the existing void invalidation also refreshes it.
export const getAutoGtBreakdownQueryKey = (engagementId?: string) =>
  [QUERY_KEY, engagementId, AUTO_GT_BREAKDOWN_QUERY_KEY_SUFFIX] as const

export function useGetAutoGtBreakdown(engagementId?: string, options?: { enabled?: boolean }) {
  return useQuery<AutoGtBreakdown | null, Error>({
    queryKey: getAutoGtBreakdownQueryKey(engagementId),
    queryFn: async () => {
      const { data } = await apiClient.get<AutoGtBreakdown | null>(
        `/int/v3/engagements/${engagementId}/auto-gt-breakdown`
      )
      return data ?? null
    },
    enabled: Boolean(engagementId) && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
